import { render, staticRenderFns } from "./IngredientsSheet.vue?vue&type=template&id=c88e4750&"
import script from "./IngredientsSheet.vue?vue&type=script&lang=ts&"
export * from "./IngredientsSheet.vue?vue&type=script&lang=ts&"
import style0 from "./IngredientsSheet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports